var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnMute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_148_1157",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0834961,
    y: 0.961693,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_148_1157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5565 23.1002L16.5413 20.0847C16.1951 20.3065 15.8304 20.4989 15.447 20.6617C15.0637 20.8245 14.6669 20.961 14.2565 21.0712V19.5212C14.4707 19.4444 14.679 19.3659 14.8815 19.2857C15.0842 19.2055 15.2759 19.1104 15.4565 19.0002L11.872 15.4154V19.7499L7.58352 15.4617H3.87202V10.4617H6.91827L2.07977 5.62319L3.13352 4.56944L20.6103 22.0462L19.5565 23.1002ZM19.068 17.6944L17.993 16.6194C18.3405 16.0771 18.6059 15.4954 18.7893 14.8742C18.9726 14.253 19.0643 13.6072 19.0643 12.9367C19.0643 11.4214 18.6236 10.0599 17.7423 8.85219C16.8608 7.64436 15.6989 6.81103 14.2565 6.35219V4.80219C16.1245 5.30086 17.6428 6.30019 18.8113 7.80019C19.9799 9.30019 20.5643 11.0124 20.5643 12.9367C20.5643 13.8137 20.4339 14.6557 20.173 15.4627C19.912 16.2697 19.5437 17.0136 19.068 17.6944ZM16.0065 14.6329L14.2565 12.8829V9.25794C14.9309 9.62461 15.452 10.1409 15.82 10.8069C16.188 11.4729 16.372 12.1912 16.372 12.9617C16.372 13.2565 16.3415 13.544 16.2805 13.8242C16.2197 14.1044 16.1284 14.3739 16.0065 14.6329ZM11.872 10.4982L9.71427 8.33094L11.872 6.17344V10.4982ZM10.372 16.1117V13.9154L8.41827 11.9617H5.37202V13.9617H8.22202L10.372 16.1117Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnMute);
export default __webpack_public_path__ + "static/media/unMute.40c5575a11bf581fbdc98d4d4d0aa236.svg";
export { ForwardRef as ReactComponent };